import React from "react";
import {
  createRestyleComponent,
  createText,
  createVariant,
  VariantProps,
} from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";

const Text = createText<Theme>();

const MText = createRestyleComponent<
  VariantProps<Theme, "body"> & React.ComponentProps<typeof Text>,
  Theme
>([createVariant({ themeKey: "body" })], Text);

const MainText = (
  props: VariantProps<Theme, "body"> & React.ComponentProps<typeof Text>,
) => <MText maxFontSizeMultiplier={1.2} {...props} />;

export { MainText };
